// extracted by mini-css-extract-plugin
export default {"countdown":"g_-z","srOnly":"h_-z"};